<div *ngFor="let m of messages">{{m}}</div>
